export default function KPI({ label, value, unit, sub, accent = false, testid }) {
  return (
    <div className={`p-6 border ${accent ? "border-[var(--signal)] bg-[var(--signal-light)]" : "border-black/15 bg-[var(--paper)]"}`} data-testid={testid}>
      <div className="label-mono">{label}</div>
      <div className="mt-3 flex items-baseline gap-2">
        <div className="text-4xl sm:text-5xl font-light tracking-tighter tabular-nums">{value}</div>
        {unit && <div className="text-sm text-[var(--muted)] font-mono">{unit}</div>}
      </div>
      {sub && <div className="mt-2 text-xs text-[var(--muted)] font-mono">{sub}</div>}
    </div>
  );
}
